export type DateFormat =
  | "api"
  | "moment"
  | "DD-MM-yyyy"
  | "yyyyMMDD"
  | "yyyy-MM-DD";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function date(value: Date | string) {
  const resolvedValue: Date =
    typeof value === "string" ? new Date(value) : value;

  const formatter = {
    format(format: DateFormat = "DD-MM-yyyy") {
      const day = resolvedValue.getDate();
      const month = resolvedValue.getMonth() + 1;
      const year = resolvedValue.getFullYear();
      const twoDigitsMonth = ("0" + (resolvedValue.getMonth() + 1)).slice(-2);
      const twoDigitsDay = ("0" + resolvedValue.getDate()).slice(-2);

      switch (format) {
        case "api": {
          return `${year}-${month}-${day}T00:00:00`;
        }
        case "moment": {
          return `${month}-${day}-${year}`;
        }
        case "yyyyMMDD": {
          return `${year}${month}${day}`;
        }
        case "yyyy-MM-DD": {
          return `${year}-${twoDigitsMonth}-${twoDigitsDay}`;
        }
        default: {
          return `${day}-${month}-${year}`;
        }
      }
    },
  };

  return {
    value,
    add(numberOfDays: number) {
      resolvedValue.setDate(resolvedValue.getDate() + numberOfDays);
      return formatter;
    },
    format: formatter.format,
  };
}

function now() {
  return date(new Date());
}

function monthLabel(date: Date) {
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return `${monthNames[monthIndex]} ${year}`;
}

function nextMonthLabel(date: Date) {
  const nextMonthIndex = (date.getMonth() + 1) % 12;
  const year = date.getFullYear() + (nextMonthIndex === 0 ? 1 : 0);

  return `${monthNames[nextMonthIndex]} ${year}`;
}

function nextMonthFirstDayLabel(date: Date) {
  const nextMonthIndex = (date.getMonth() + 1) % 12;
  const year = date.getFullYear() + (nextMonthIndex === 0 ? 1 : 0);

  const formattedDate = new Date(year, nextMonthIndex, 1);

  const formattedWeekDay = dayNames[formattedDate.getDay()];
  const formattedMonthDay = formattedDate.getDate().toString().padStart(2, "0");
  const formattedMonthName = monthNames[formattedDate.getMonth()].slice(0, 3);

  const formattedString = `${formattedWeekDay} ${formattedMonthDay} ${formattedMonthName} ${formattedDate.getFullYear()}`;

  return formattedString;
}

export { date, now, monthLabel, nextMonthLabel, nextMonthFirstDayLabel };
